import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BudgetPeriodConfigForm } from '@/components/financial/BudgetPeriodConfigModal';
import { useCurrentBudgetPeriod } from '@/hooks/use-financial';

export default function BudgetPeriodConfigPage() {
  const navigate = useNavigate();
  const { data: currentPeriod } = useCurrentBudgetPeriod();
  const handleBack = () => navigate(-1);

  return (
    <div className="min-h-[calc(100vh-4rem)] p-6 flex items-center justify-center">
      <Card className="w-full max-w-2xl border-border/60 shadow-xl shadow-black/10">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5 text-primary" />
            Configurar Período Orçamentário
          </CardTitle>
          <CardDescription className="text-left">
            É o intervalo de 30 dias entre a data prevista de recebimento de uma receita e outra.
            Informe a data esperada da sua receita principal. Esta definirá o seu Período Orçamentário.
            Por exemplo, se você espera receber no dia 5, seu período vai do dia 5 de um mês até o dia 4
            do mês seguinte. Evite trocar o período a cada mês.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <BudgetPeriodConfigForm
            currentPeriod={currentPeriod}
            onSuccess={handleBack}
            onCancel={handleBack}
            cancelLabel="Voltar"
          />
        </CardContent>
      </Card>
    </div>
  );
}
